/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

type State<Data> = {
  data?: Data;
  loading: boolean;
  error?: any;
  response?: any;
};

export type UseApiReturn<Data = any> = [State<Data>, () => void];

const useApi = <Data = any>(
  call: () => Promise<any>,
  deps: readonly any[] = [],
  options?: { lazy?: boolean }
): UseApiReturn<Data> => {
  const [state, setState] = useState<State<Data>>({ loading: !options?.lazy });

  const query = () => {
    call()
      .then((response) => {
        setState({
          data: response?.data,
          loading: false,
          response,
        });
      })
      .catch((error) => {
        setState({
          loading: false,
          error,
        });
      });
  };

  useEffect(() => {
    if (!options?.lazy) query();
  }, deps);

  return [state, query];
};

export default useApi;
